import formatPrice from 'app/utils/price';
import pluralize from 'app/utils/pluralize';

/* -------------------------NODES-------------------------*/

const mainBannerRootNode = document.querySelector('#trialMainBlockRoot');
const mainTitleNode = document.querySelector('#newTrialBannerHeading');
const mainTrialSaleBannerTitleNode = document.querySelector('#mainTrialSaleBannerTitle');
const saleAmountMobileNode = document.querySelector('#saleAmountMobile');
const saleAmountDesktop = document.querySelector('#saleAmountDesktop');
const noSaleBlock = document.querySelector('#noSaleBlock');
const miragoshaDiscountNode = document.querySelector('#saleAmountNode');
const saleAmountDigitMobileNode = document.querySelector('#saleAmountDigitMobile');
const saleAmountDigitDesktopNode = document.querySelector('#saleAmountDigitDesktop');

const totalPriceDesktopNode = document.querySelector('#totalPriceDesktop');
const totalPriceMobileNode = document.querySelector('#totalPriceMobile');
const originalPriceDesktopNode = document.querySelector('#originalPriceDesktop');
const originalPriceMobileNode = document.querySelector('#originalPriceMobile');
const dishesAmountMobileNode = document.querySelector('#dishesAmountMobile');
const dishesAmountDesktopNode = document.querySelector('#dishesAmountDesktop');
const dishesAmountDesktopUnitsNode = document.querySelector('#dishesAmountDesktopUnits');
const dishesAmountMobileUnitsNode = document.querySelector('#dishesAmountMobileUnits');

const salesNodeForAI1 = document.querySelector('#saleAmountAi1');
const salesNodeForAI2 = document.querySelector('#saleAmountAi2');
const salesNodeForAI3 = document.querySelector('#saleAmountAi3');

const aiTrialPriceNodes = document.querySelectorAll('.a-399-text-node');

export const mutateTrialDOMSalesNodes = ({
    originalPrice, discountPercent,
}) => {
    if (mainTitleNode) {
        mainTitleNode.innerHTML = ` Привет,<span class="mainTrialBannerSmallText"> это</span>
        <br />
        пробный сет`;
    }
    if (mainTrialSaleBannerTitleNode) {
        mainTrialSaleBannerTitleNode.innerText = 'со скидкой';
    }
    if (saleAmountMobileNode && discountPercent < 100) {
        saleAmountMobileNode.classList.remove('hidden');
    }
    if (saleAmountDesktop) {
        saleAmountDesktop.classList.toggle('hidden', discountPercent >= 100);
    }
    if (noSaleBlock) {
        noSaleBlock.classList.add('hidden');
    }
    if (saleAmountDigitMobileNode) {
        saleAmountDigitMobileNode.innerText = `-${100 - discountPercent}`;
    }
    if (saleAmountDigitDesktopNode) {
        saleAmountDigitDesktopNode.innerText = `-${100 - discountPercent}`;
    }
    if (salesNodeForAI1) {
        salesNodeForAI1.innerText = `-${100 - discountPercent}%`;
    }
    if (salesNodeForAI2) {
        salesNodeForAI2.innerText = `-${100 - discountPercent}%`;
    }
    if (salesNodeForAI3) {
        salesNodeForAI3.innerText = `-${100 - discountPercent}%`;
    }
    if (originalPriceDesktopNode) {
        originalPriceDesktopNode.innerText = `${formatPrice(originalPrice)} ₽`;
        originalPriceDesktopNode.classList.remove('underlined');
        originalPriceDesktopNode.classList.add('crossed');
    }
    if (originalPriceMobileNode) {
        originalPriceMobileNode.innerHTML = `для вас <br /> вместо ${formatPrice(originalPrice)} ₽`;
    }
    if (aiTrialPriceNodes.length) {
        aiTrialPriceNodes.forEach((node) => {
            node.innerText = formatPrice(4200 * (discountPercent / 100));
        });
    }
};

export const insertDiscountAmount = (discountPercent) => {
    if (saleAmountDigitDesktopNode && miragoshaDiscountNode) {
        miragoshaDiscountNode.style.visibility = 'visible';
        saleAmountDigitDesktopNode.innerText = `-${100 - discountPercent}`;
    }
};

export const mutateTrialDOMNodes = ({ totalCommonPrice }) => {
    if (totalPriceDesktopNode) {
        totalPriceDesktopNode.innerText = `${formatPrice(totalCommonPrice)} ₽`;
    }
    if (totalPriceMobileNode) {
        totalPriceMobileNode.firstChild.remove();
        const newPrice = document.createElement('span');
        newPrice.innerText = formatPrice(totalCommonPrice);
        totalPriceMobileNode.insertBefore(newPrice, totalPriceMobileNode.firstChild);
    }
};

export const disableGetWelcomeDiscountButton = () => {
    if (originalPriceMobileNode) {
        const parentOriginalPriceMobileNode = originalPriceMobileNode.parentNode;
        parentOriginalPriceMobileNode.style.alignItems = 'center';
        originalPriceMobileNode.innerHTML = 'за весь набор';
    }
    if (originalPriceDesktopNode) {
        originalPriceDesktopNode.innerHTML = 'за весь набор';
        originalPriceDesktopNode.classList.remove('underlined');
        originalPriceDesktopNode.classList.remove('crossed');
    }
};

export const mutateUnitsTextDependingOnAmount = () => {
    if (dishesAmountMobileNode && dishesAmountMobileUnitsNode) {
        const { value } = dishesAmountMobileNode.dataset;
        dishesAmountMobileUnitsNode.innerHTML = pluralize(value, ['супер-<br />блюдо', 'супер-<br />блюда', 'супер-<br />блюд']);
    }
    if (dishesAmountDesktopNode && dishesAmountDesktopUnitsNode) {
        const { value } = dishesAmountMobileNode.dataset;
        dishesAmountDesktopUnitsNode.innerHTML = pluralize(value, ['суперблюдо', 'суперблюда', 'суперблюд']);
    }
};
